module.exports = "/_next/static/media/41004f4fe3f4ba20e0a460423b57338a.svg";